import classNames from "classnames";
import React, { useCallback, useLayoutEffect, useMemo } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import iconReturn from "../../assets/icons/ic-return.svg";
import pacificoLogoAsset from "../../assets/images/pages/shared/logo-pacifico.png";
import bcpLogoAsset from "../../assets/images/pages/shared/bcp-logo.png";
import {
    ROUTE_APP_EMPTY,
    ROUTE_APP_QUOTATION,
} from "../../constants/routes/app";
import { useWindowResolution } from "../../hooks/use-window-resolution";
import { isDefined } from "../../libs/utils/object";
import { ClearPayrollFile } from "../../redux/payroll-file/actions/default";
import { ClearQuotation } from "../../redux/quotation/actions/default";
import { Row } from "../layout/flex-layout";
import "./header.scss";
import { useChannel } from "../../libs/channels/hooks/use-channel";

const BackButton = () => {
    const { normalizedPathname } = useChannel();
    const isBackVisible = useMemo(
        () => normalizedPathname !== ROUTE_APP_EMPTY,
        [normalizedPathname]
    );
    const history = useHistory();
    const { isMobile } = useWindowResolution();
    const dispatch = useDispatch();
    useLayoutEffect(() => {
        window.scrollTo && window.scrollTo(0, 0);
    }, [normalizedPathname]);
    const goBack = useCallback(() => {
        if (normalizedPathname === ROUTE_APP_QUOTATION) {
            dispatch(new ClearQuotation().create());
            dispatch(new ClearPayrollFile().create());
        }
        history.goBack();
    }, [normalizedPathname, history, dispatch]);

    return (
        isBackVisible && (
            <div className="header__back" onClick={goBack}>
                <img src={iconReturn} alt="retroceder" />
                {isMobile ? "" : "Regresar"}
            </div>
        )
    );
};

type propsType = {
    visible?: boolean;
};

const Header: React.FC<propsType> = (props: propsType) => {
    const { normalizedPathname } = useChannel();
    const isVisibleHeader = useMemo(
        () =>
            isDefined(props.visible)
                ? props.visible
                : normalizedPathname !== ROUTE_APP_EMPTY,
        [normalizedPathname]
    );
    const { isBcpTheme } = useChannel();
    return (
        isVisibleHeader && (
            <Row
                className={classNames("header", {
                    bcp: isBcpTheme,
                })}
                data-testid="header"
            >
                <Row
                    className="header__content"
                    justify={isBcpTheme ? "space-around" : "center"}
                    align="center"
                >
                    <BackButton />
                    <img
                        className="header__logo"
                        src={pacificoLogoAsset}
                        alt="pacifico logo"
                    />
                    {isBcpTheme && (
                        <img
                            className="bcp"
                            src={bcpLogoAsset}
                            alt="bcp logo"
                        />
                    )}
                </Row>
            </Row>
        )
    );
};

export default Header;
